/* eslint-disable max-len */
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import styles from './WMICPremiumBoxSummary.module.scss';
import messages from './WMICPremiumBox.messages';

import { IntlContext } from '@jutro/legacy/locale';

const WMICPremiumBoxSummary = ({
    fullAmount,
    tempSupplementalFeeEnabled
}) => {
    const translator = useTranslator();
    const intl = useContext(IntlContext);

    const formattedAmount = (currAmount) => intl.formatNumber(
        _.get(currAmount, 'amount'),
        {
            style: 'currency',
            currency: _.get(currAmount, 'currency'),
            currencyDisplay: 'symbol'
        }
    );

    const getPaymentAmountDisplay = (amount) => {
        const formattedAmt = formattedAmount(amount);
        return tempSupplementalFeeEnabled ? `${formattedAmt}*` : formattedAmt;
    };

    return (
        <div className={styles.WMICPremiumBox}>
            <div className={styles.key}>{tempSupplementalFeeEnabled ? translator(messages.yourPolicyTotal) : translator(messages.yourTotalPremium)}</div>
            <div className={styles.value}>{getPaymentAmountDisplay(fullAmount)}</div>
        </div>
    );
};

WMICPremiumBoxSummary.propTypes = {
    fullAmount: PropTypes.string,
    tempSupplementalFeeEnabled: PropTypes.bool
};

WMICPremiumBoxSummary.defaultProps = {
    fullAmount: undefined,
    tempSupplementalFeeEnabled: false
};

export default WMICPremiumBoxSummary;